import { NavLink, Outlet } from 'react-router-dom';

import { useAuth } from '../../hooks/useAuth';

export default function AdminLayout() {
  const { hasCapability } = useAuth();

  if (!hasCapability('admin')) {
    return (
      <div className="admin-guard">
        <h2>Admin Access Required</h2>
        <p style={{ color: '#cbd5f5', maxWidth: '480px' }}>
          You need administrator permissions to access this area. Sign in with an administrator account or contact your
          system owner for help.
        </p>
      </div>
    );
  }

  return (
    <div className="admin-shell">
      <aside className="admin-nav">
        <h2>A.R.E.S Admin</h2>
        <p>Manage users, devices, deployment locations, and agent credentials.</p>
        <nav>
          <NavLink to="/admin/users" className={({ isActive }) => (isActive ? 'active' : '')}>
            Users
          </NavLink>
          <NavLink to="/admin/devices" className={({ isActive }) => (isActive ? 'active' : '')}>
            Devices
          </NavLink>
          <NavLink to="/admin/agents" className={({ isActive }) => (isActive ? 'active' : '')}>
            Agents
          </NavLink>
          <NavLink to="/admin/locations" className={({ isActive }) => (isActive ? 'active' : '')}>
            Locations
          </NavLink>
        </nav>
      </aside>
      <main className="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
